export default __webpack_public_path__ + "static/media/img5.fdd0e79c.jpg";